import { AC3BaseError } from './AC3BaseError';
import { InvalidArgumentError } from './InvalidArgumentError';
/**
 * @class DisplayableError
 * Error type that guarantees error contains localized display message.
 */
export class DisplayableError extends AC3BaseError {
    constructor(message, displayContext, cause, errorCodeContextInputs) {
        if (displayContext == undefined || displayContext == null) {
            throw new InvalidArgumentError('Must give defined and non-null input for displayContext.');
        }
        super(message, cause, errorCodeContextInputs, displayContext);
        this.name = 'DisplayableError';
    }
}
//# sourceMappingURL=DisplayableError.js.map